export default {
  setSignatureKey (state, key) {
    state.value = key
  }
}
